module.exports = __webpack_public_path__ + "img/Epicorlogo.a7aa7870.jpg";